export const FETCH_PRIVATE_PRACTITIONER_REQUEST = 'FETCH_PRIVATE_PRACTITIONER_REQUEST'
export const FETCH_PRIVATE_PRACTITIONER_SUCCESS = 'FETCH_PRIVATE_PRACTITIONER_SUCCESS'
export const FETCH_PRIVATE_PRACTITIONER_FAILURE = 'FETCH_PRIVATE_PRACTITIONER_FAILURE'

export const UNREGISTER_PRIVATE_PRACTITIONER_REQUEST = 'UNREGISTER_PRIVATE_PRACTITIONER_REQUEST'
export const UNREGISTER_PRIVATE_PRACTITIONER_SUCCESS = 'UNREGISTER_PRIVATE_PRACTITIONER_SUCCESS'
export const UNREGISTER_PRIVATE_PRACTITIONER_FAILURE = 'UNREGISTER_PRIVATE_PRACTITIONER_FAILURE'

export const FETCH_PRIVATE_PRACTITIONER_FILE_REQUEST = 'FETCH_PRIVATE_PRACTITIONER_FILE_REQUEST'
export const FETCH_PRIVATE_PRACTITIONER_FILE_SUCCESS = 'FETCH_PRIVATE_PRACTITIONER_FILE_SUCCESS'
export const FETCH_PRIVATE_PRACTITIONER_FILE_FAILURE = 'FETCH_PRIVATE_PRACTITIONER_FILE_FAILURE'
